import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Check, X, Download } from "lucide-react";

export default function AdminHplRegistrations() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState(null);
  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/admin/hpl-registrations"); setItems(r.data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const verify = async (r, ok) => {
    try { await api.put(`/admin/hpl-registrations/${r.id}/verify?verified=${ok}`); toast.success(ok ? "Verified" : "Marked rejected"); load(); if (view) setView(null); }
    catch { toast.error("Failed"); }
  };
  const del = async (r) => {
    if (!window.confirm(`Delete HPL registration for ${r.player_name}?`)) return;
    try { await api.delete(`/admin/hpl-registrations/${r.id}`); toast.success("Deleted"); load(); if (view) setView(null); }
    catch { toast.error("Failed"); }
  };
  const exportCsv = () => {
    const rows = [["Player", "Team", "Stats", "Role", "UTR", "Payment", "Submitted"]];
    items.forEach((r) => rows.push([r.player_name, r.team, r.stats, r.role, r.utr, r.payment_status, new Date(r.created_at).toLocaleString()]));
    const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
    const a = document.createElement("a"); a.href = url; a.download = `NDPL-HPL-Registrations-${new Date().toISOString().slice(0,10)}.csv`; a.click(); URL.revokeObjectURL(url);
  };
  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">HPL Auction Registrations</div>
          <h1 className="font-display text-4xl mt-2">HPL Registrations</h1>
        </div>
        <button onClick={exportCsv} className="px-4 py-2 bg-[#39FF14] text-black text-xs uppercase tracking-widest font-bold flex items-center gap-2"><Download size={14}/>Download CSV</button>
      </div>
      <div className="mt-4 text-sm text-white/60">{items.length} registration{items.length !== 1 ? "s" : ""}</div>
      {loading ? <div className="mt-6 text-white/50">Loading…</div> : (
        <div className="mt-6 overflow-x-auto border border-white/10 rounded">
          <table className="w-full text-sm">
            <thead className="bg-[#151F3D] text-white/70">
              <tr>{["Player", "Team", "Role", "UTR", "Payment", "Submitted", ""].map((h) => (
                <th key={h} className="px-3 py-3 text-left text-xs uppercase tracking-widest">{h}</th>))}</tr>
            </thead>
            <tbody>
              {items.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-white/40">No registrations yet.</td></tr>}
              {items.map((r) => (
                <tr key={r.id} className="border-t border-white/5 hover:bg-white/5 cursor-pointer" onClick={() => setView(r)}>
                  <td className="px-3 py-3">{r.player_name}</td>
                  <td className="px-3 py-3 text-xs text-[#FFD700]">{r.team}</td>
                  <td className="px-3 py-3 text-xs">{r.role}</td>
                  <td className="px-3 py-3 font-mono text-xs">{r.utr}</td>
                  <td className="px-3 py-3">
                    <span className={`text-xs px-2 py-1 border ${r.payment_status === "verified" ? "border-[#39FF14] text-[#39FF14]" : r.payment_status === "rejected" ? "border-[#FF2442] text-[#FF2442]" : "border-[#FFD700] text-[#FFD700]"}`}>{r.payment_status}</span>
                  </td>
                  <td className="px-3 py-3 text-xs text-white/50">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="px-3 py-3" onClick={(e) => e.stopPropagation()}>
                    <div className="flex gap-1">
                      <button onClick={() => verify(r, true)} className="p-2 text-[#39FF14] hover:bg-[#39FF14]/20" title="Verify"><Check size={14}/></button>
                      <button onClick={() => verify(r, false)} className="p-2 text-[#FF2442] hover:bg-[#FF2442]/20" title="Reject"><X size={14}/></button>
                      <button onClick={() => del(r)} className="p-2 text-white/60 hover:bg-white/10" title="Delete"><Trash2 size={14}/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {view && (
        <div className="fixed inset-0 bg-black/80 z-50 grid place-items-center p-4" onClick={() => setView(null)}>
          <div className="bg-[#0B132B] border border-white/15 max-w-2xl w-full p-6 rounded-lg overflow-y-auto max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h2 className="font-display text-3xl">{view.player_name}</h2>
              <button onClick={() => setView(null)} className="text-white/60"><X /></button>
            </div>
            <div className="mt-2 text-[#FFD700] font-display">{view.team}</div>
            <div className="mt-3 text-white/80 text-sm">{view.stats}</div>
            <div className="mt-5 grid md:grid-cols-2 gap-5">
              <div className="space-y-2 text-sm">
                <div><span className="text-white/50 uppercase text-xs tracking-widest">Role: </span>{view.role}</div>
                <div><span className="text-white/50 uppercase text-xs tracking-widest">UTR: </span><span className="font-mono">{view.utr}</span></div>
                <div><span className="text-white/50 uppercase text-xs tracking-widest">Payment: </span>{view.payment_status}</div>
                <div><span className="text-white/50 uppercase text-xs tracking-widest">Submitted: </span>{new Date(view.created_at).toLocaleString()}</div>
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-white/60 mb-2">Player Photo</div>
                {view.photo_data_url ? <img src={view.photo_data_url} alt={view.player_name} className="w-full max-h-72 object-contain bg-black/30 border border-white/10"/> : <div className="text-white/40 text-sm">Not uploaded</div>}
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              <button onClick={() => verify(view, true)} className="px-4 py-2 bg-[#39FF14] text-black uppercase text-xs tracking-widest font-bold flex items-center gap-2"><Check size={14}/>Verify</button>
              <button onClick={() => verify(view, false)} className="px-4 py-2 bg-[#FF2442] text-white uppercase text-xs tracking-widest font-bold flex items-center gap-2"><X size={14}/>Reject</button>
              <button onClick={() => del(view)} className="px-4 py-2 border border-[#FF2442] text-[#FF2442] uppercase text-xs tracking-widest font-bold flex items-center gap-2"><Trash2 size={14}/>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
